import StatisticsByDayActions from '../../../../actions/StatisticsByDayActions';
import PublisherActions from '../../../../actions/PublisherActions';
import LinksActions from '../../../../actions/LinksActions';
import config from '../../../../config';
import store from '../../../../stores/redux';
import ReportByDayComponent from "../../../../utils/ReportByDayComponent/ReportByDayComponent";
import {metrics} from "../../../../utils/ReportByDayComponent/config";

const reportUtils = ReportByDayComponent.utils;

export const actions = {
    search(state) {
        const user = store.getState().user;
        const count = state.count;

        let columns = reportUtils.getKeysMetric(state.metrics);
        if (!columns.length) {
            columns = reportUtils.getKeysMetric(reportUtils.getDefStrMetric());
        }
        if (!columns.length) {
            columns = [];
            Object.keys(metrics).map(function (metric) {
                if (true === metrics[metric].visible) {
                    columns.push(metric);
                }
            });
        }

        const params = {
            publishers: [],
            group_by: state.groupBy,
            from_day: state.startDate.format(config.reportDateFormat),
            to_day: state.endDate.format(config.reportDateFormat),
            timezone: 'UTC', // these reports are built in UTC only (the timezone field on the page is read-only UTC)
            currency: user?.publisher?.account?.balance?.currency || 'USD',
            sort: state.sort,
            order: state.order,
            page: state.page,
            segments: state.segments && Object.keys(state.segments || {}).length ? JSON.stringify(state.segments) : undefined,
            count,
            columns: columns,
            totals: '1'
        };

        StatisticsByDayActions.searchData(params, () => {
            const dataStatistics = store.getState().statistics.data;

            if (!dataStatistics.ids.length) {
                return;
            }

            const followUpParams = {
                count,
                ids: dataStatistics.ids
            };

            switch (dataStatistics.parameters.group_by) {
                case 'Goal':
                    PublisherActions.getGoals(followUpParams);
                    break;
                case 'Offer':
                    PublisherActions.getOffers(followUpParams);
                    break;
                case 'Link':
                    LinksActions.getListLinks(followUpParams);
                    break;
                default:
                    break;
            }
        });
    }
};
